import { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { auth } from "../firebase";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
// import { auth } from "../firebase";

const Signin = ({ uid }) => {
  const [showPassword, setShowPassword] = useState(false);
  const email = useRef();
  const password = useRef();
  const history = useHistory();
  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);
  useEffect(() => {
    if (user) {
      history.push("/user");
    }
  }, [user]);
  useEffect(() => {
    if (error) {
      let message = "";
      switch (error.code) {
        case "auth/user-not-found":
          message = "User with this email not registered!";
          break;
        case "auth/wrong-password":
          message = "Password you entered is incorrect!";
          break;
        case "auth/too-many-requests":
          message = "You reached the maximum requests count. Please try again later.";
          break;
        default:
          message =
            "Error occured while signing you in! Please try again later.If this error occures continuesly please contact us.";
          break;
      }
      alert(message);
    }
  }, [error]);
  const handleSignin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(email.current.value, password.current.value);
  };
  return (
    <div className="flex flex-col w-full overflow-y-auto h-full py-12">
      <div className="text-2xl sm:text-3xl font-bold">Sign in</div>
      <form onSubmit={handleSignin} className="mt-12 flex flex-col">
        <input
          type="email"
          name=""
          ref={email}
          placeholder="Email"
          className="px-4 py-2 mb-4 w-full max-w-xs border border-black border-opacity-20"
        />
        <div className="flex items-center ">
          <input
            type={showPassword ? "text" : "password"}
            name=""
            ref={password}
            placeholder="Password"
            className="px-4 py-2 mb-4 w-full max-w-xs border border-black border-opacity-20"
          />
          <div
            className="h-max flex items-center w-max ml-2 cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "hide" : "show"}
          </div>
        </div>
        <button className="w-max max-w-full bg-blue px-4 py-2 text-white ">
          Submit
        </button>
        {loading && <p className="text-base w-full italic mt-4">Signing in...</p>}
      </form>
      <div className="mt-8 text-lg w-full">
        New member ?{" "}
        <Link to="/sign-up" className="underline">
          Sign up
        </Link>
      </div>
    </div>
  );
};

export default Signin;
